<template>
	<div>
		<Row>
			<Col span="15">
			<div class="member_list">
				<!--div>
					<div style="justify-content: center;padding-left: 100px;">
						<Button type="primary" @click.stop="addTissue">添加部门</Button>
						<div class="form-inline-block" style="padding-left: 50px;">
							<Button type="primary" @click.stop="editTissue">编辑部门</Button>
						</div>
						<div class="form-inline-block" style="padding-left: 50px;">
							<Button type="primary" @click.stop="delTissue">删除部门</Button>
						</div>
					</div>
				</div-->
				<vue2-org-tree style="margin: 30px;" :data="departmentTree" :horizontal="false" name="test"
					@on-node-click="NodeClick" :judge="judge"
					:renderContent="renderContent"  @on-expand="onExpand"  />
			</div>
			</Col>

		</Row>
		<Row>
			<Col span="15">
			<div class="member_list">
				<div style="display: flex;">
					<div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">成员</div>
			
					<Dropdown trigger="click" style="margin-left: 50px" @on-click="addMember">
						<Button type="primary">+添加成员</Button>
						<DropdownMenu slot="list">
							<DropdownItem v-for="(role, key) in newRoleList" :name="key">{{ role.name }}</DropdownItem>
						</DropdownMenu>
					</Dropdown>
				</div>
				<Table :columns="memberColumn" :data="memberList">
					<template slot-scope="{ row }" slot="head">
						<div style="display: flex; align-items: center; height: 60px; ">
							<img style="width: 50px; height: 50px;border-radius: 50%" :src="row.ext_info.avatar" />
						</div>
					</template>
					<template slot-scope="{ row }" slot="official">
						<i-switch v-model="row.official" @on-change="change" />
					</template>
					<template slot-scope="{ row }" slot="userNum">
						<span>{{row.id+1000}}</span>
					</template>
					<template slot-scope="{ row }" slot="operation">
						<div>
							<div style="display: flex;">
								<div class="fill" style="margin-left: 10px;" @click="editRoleClick"
									:data-role="row.role" :data-department="row.department" :data-openpool="row.is_open_pool" :data-name="row.name"
									:data-id="row.id" :data-phone="row.phone">编辑
								</div>
								<div class="fill" style="margin-left: 10px;" @click="deleteRoleClick" :data-id="row.id"
									:data-name="row.name">移除
								</div>
                <Poptip
                    v-if="row.boundOTP"
                    confirm
                    title="确定解绑吗？"
                    @on-ok="unBoundOTP(row)">
                  <div class="fill" style="margin-left: 10px;">重置授权二维码</div>
                </Poptip>
							</div>
			
						</div>
					</template>
				</Table>
			</div>
			</Col>
		</Row>
		<!-- 新建对话框 -->
		<Modal v-model="addTissueShow" width='400' @on-ok="addOkClick">
			<div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">新增部门</div>
			<Form :model="addTissueItem" :label-width="90">
				<FormItem label="部门名称">
					<Input v-model="addTissueItem.name" placeholder="请输入部门名称"></Input>
				</FormItem>
				<FormItem label="上级部门">
					<Select v-model="addTissueItem.parent_id" style="width:150px" placeholder="上级部门">
						<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="部门负责人">
					<Select v-model="addTissueItem.department_principal" style="width:150px" placeholder="部门负责人">
						<Option v-for="item in teamList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="editTissueShow" width='400' @on-ok="editOkClick">
			<div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">编辑</div>
			<Form :model="editTissueItem" :label-width="80">
				<FormItem label="部门名称">
					<Input v-model="editTissueItem.name" placeholder="请输入部门名称"></Input>
				</FormItem>
				<FormItem label="上级部门" v-if="editTissueItem.parent_id !=0">
					<Select v-model="editTissueItem.parent_id" style="width:150px" placeholder="上级部门">
						<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="部门负责人">
					<Select v-model="editTissueItem.department_principal" style="width:150px" placeholder="部门负责人">
						<Option v-for="item in teamList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</FormItem>
			</Form>
		</Modal>
		<!-- 添加成员对话框 -->
		<Modal ok-text="确认添加" v-model="addMemberShow" width='400' @on-ok="addMemberOkClick">
			<div style="color: #515A6E; font-weight: bold; margin-bottom: 10px;">添加成员为{{ addValue }}</div>
			<Input v-model="addUser['name']" placeholder="请输入姓名" style="width: 300px" />
			<Input v-model="addUser['phone']" placeholder="请输入手机号" style="width: 300px; margin-top: 10px" />
			<Input v-model="addUser['password']" placeholder="请输入密码" style="width: 300px; margin-top: 10px" />
			<!--            <div style="margin-bottom: 5px;">以账号形式添加</div>-->
			<!--            <div v-for="(item,index) in addValueList" :key="index"-->
			<!--                 style="display: flex; align-items: center; justify-content: space-between; margin: 10px 0;">-->
			<!--                <Input v-model="addValueList[index]" placeholder="请输入手机号或账号" style="width: 300px"/>-->
			<!--                <div v-if="index > 0" @click="deleteMemberList" :data-index="index" style="color: #277dd3;"-->
			<!--                     class="icon iconfont icon-jian"></div>-->
			<!--            </div>-->
			<!--            <a @click="addMemberList" style="display: flex;align-items: center;" href="javascript:vold(0)"><span-->
			<!--                    style="color: #277dd3;"-->
			<!--                    class="icon iconfont icon-jia"></span><span>增加成员</span></a>-->
		</Modal>
		<!-- 编辑角色对话框 -->
		<Modal v-model="editMemberShow" width='400' @on-ok="editMemberOkClick">
			<div style="color: #515A6E; font-weight: bold; margin-bottom: 10px;">编辑角色-{{ editRoleForm.editNameValue }}
			</div>
			<Form :model="editRoleForm" :label-width="80">
				<FormItem label="所属组织">
					<Select v-model="editRoleForm.editBranchValue" style="width:200px">
						<Option v-for="item in departmentList" :value="item.id" :key="item.id">{{ item.name }}</Option>
					</Select>
				</FormItem>
				<FormItem label="角色" v-if="userInfo.role_type == 4 || userInfo.role_type == 1">
					<Select v-model="editRoleForm.editRoleValue" style="width:200px">
						<Option v-for="item in roleList" :value="item.id" :key="item.id">{{ item.name }}</Option>
					</Select>
				</FormItem>							
				<FormItem label="密码">
					<Input v-model="editRoleForm.password" placeholder="如不需要重置密码请留空" style="width: 200px" />
				</FormItem>
				<FormItem label="账号">
					<Input v-model="editRoleForm.phone" placeholder="请输入员工登录手机" style="width: 200px" />
				</FormItem>
				<FormItem label="是否开启公共池">
					<i-switch v-model="editRoleForm.is_open_pool" >
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</FormItem>
			</Form>
		</Modal>
		<!-- 移除对话框 -->
		<Modal ok-text="确认删除" v-model="deleteMemberShow" width='400' @on-ok="deleteMemberOkClick">
			<div style="color: #515A6E; font-weight: bold; margin-bottom: 10px;">删除{{ deleteName }}</div>
			<div>确认要将{{ deleteName }}删除吗？</div>
		</Modal>
	</div>
</template>
<script>
import {
	mapActions,
	mapGetters
} from "vuex";
import {
  getRoleList,
  getDepartmentList,
  getDepartmentLog,
  getMemberByDepartment,
  getDepartmentTree,
  getDepartmentTreeTest,
  saveDepartment,
  delDepartment,
  getTeamList,
  getUserList,
  manageUser,
  deleteUser, unBoundOTP
} from '@/api/user'
export default {
	name: "OrgTree",
	props: {
		'roleList': {

		},
		'departmentList': {

		},
		'memberList': {

		},
		department: {}
	},
	data() {
		return {
			BasicSwich: false,
			BasicInfo: {
				id: null,
				label: null
			},
			judge: {
				swtich: true
			},
			NodeClass: [
				"myred",
				"myger",
				"myblue"
			],
			addTissueItem: {
				name: '',
				parent_id: '',
				department_principal: '',
			},
			editTissueItem: {
				id: 0,
				parent_id: '',
				name: '',
				department_principal: '',
			},
			departmentTree: {},
			teamList: [],
			activeId: '',
			activeName: '',
			horizontal: false,
			collapsable: true,
			expandAll: true,
			addTissueShow: false,
			editTissueShow: false,
			labelClassName: "bg-color-orange",
			newRoleList: [],
			deleteId: 0,
			deleteName: '', //删除对话框姓名绑定
			deleteMemberShow: false, //删除角色对话框
			branchList: [{
				value: 'select',
				label: '请选择'
			},
			{
				value: 'beiJingPinLun',
				label: '北京品伦'
			},
			],

			editRoleForm: {
				id: 0,
				phone: '',
				editRoleValue: '', //编辑角色角色绑定
				editBranchValue: '', //编辑角色部门绑定
				editNameValue: '', //编辑角色标题绑定
				password: '', //密码
				is_open_pool:false
			},
			editMemberShow: false, //编辑角色对胡框显示
			addUser: {
				name: '',
				phone: '',
				password: ''
			},
			addValue: '',
			addRoleId: 0,
			addMemberShow: false, //添加成员对话框显示
			// 表格表头数据
			memberColumn: [{
				title: '头像',
				// key: 'head',
				slot: 'head',
			},
			{
				title: '姓名',
				key: 'name'
			},
			{
				title: '工号',
				slot: 'userNum'
			},
			{
				title: '账号',
				key: 'phone'
			},
			{
				title: '部门',
				key: 'department_name'
			},
			{
				title: '角色',
				key: 'role_name'
			},
			// {
			// 	title: '官网展示',
			// 	slot: 'official',
			// },
			{
				title: '加入时间',
				key: 'created_at'
			},
			{
				title: '操作',
				// key: 'operation',
				slot: 'operation',
        width: '200',
			},
			],
		};
	},
	mounted: function () {
		this.expandChange();
		this.loadData();
	},
	created(){
      this.toggleExpand(this.departmentTree, this.expandAll);
    },
	watch: {

		roleList() {
			let that = this;
			that.newRoleList = [];
		
			this.roleList.forEach(function (row) {
				if (that.userInfo.role_type == 1 || that.userInfo.role_type == 2) {
					that.newRoleList.push(row);
				} else if (that.userInfo.role_type == 4) {
					if (row.type != 1 && row.type != 3 && row.type != 4 && row.type != 12) {
						that.newRoleList.push(row);
					}
				} else if (that.userInfo.role_type == 13) {
					if (row.type == 5 || row.type == 6 || row.type == 10 || row.type == 11) {
						that.newRoleList.push(row);
					}
				} else if (that.userInfo.role_type == 5) {

					if (row.type == 10 || row.type == 11) {
					
						that.newRoleList.push(row);
					}
				}
			})
		}
	},
	computed: {
		...mapGetters(['token', 'userInfo'])
	},
	methods: {
		// 新建按钮
		addTissue() {
			this.addTissueItem.parent_id = this.activeId;
			this.addTissueShow = true
		},
		editTissue() {
			this.editTissueShow = true
		},
		delTissue(e) {
			let that = this;
			let id = this.activeId
			let data = {
				token: this.token,
				id: id
			};
			this.throttle(async function () {
				let res = await delDepartment(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					this.loadData();
				}
			}, 2000)
		},
		// 新建确定按钮
		addOkClick() {
			let that = this;
			let data = {
				token: this.token,
				name: this.addTissueItem.name,
				parent_id: this.addTissueItem.parent_id,
				department_principal: this.addTissueItem.department_principal,
			};
			this.throttle(async function () {
				let res = await saveDepartment(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					this.loadData();
				}
			}, 2000)
		},
		// 编辑确定按钮
		editOkClick() {
			let that = this;
			let data = {
				token: this.token,
				name: this.editTissueItem.name,
				id: this.activeId,
				parent_id: this.editTissueItem.parent_id,
				department_principal: this.editTissueItem.department_principal,
			};
			this.throttle(async function () {
				let res = await saveDepartment(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					this.loadData();
				}
			}, 2000)
		},
		async loadData() {
			let that = this;
			let data = {
				token: this.token,
				getSelf: 1
			};
			//树形组织结构
			var res = await getDepartmentTree(that, data);
			if (res.code == 1) {
				that.departmentTree = res.data.list;
			}
			//获取权限下的用户id
			var res = await getTeamList(that, data);
			if (res.code == 1) {
				that.teamList = res.data.list;
			}

		},
		onMouseout(e, data) {
			this.BasicSwich = false;
		},
		onMouseover(e, data) {
			this.BasicInfo = data;
			this.BasicSwich = true;
			var floating = document.getElementsByClassName("floating")[0];
			floating.style.left = e.clientX + 10 + "px";
			floating.style.top = e.clientY + 10 + "px";
		},

		onExpand(e, data) {
			if ("expand" in data) {
				data.expand = !data.expand;
				if (!data.expand && data.children) {
					this.collapse(data.children);
				}
			} else {
				this.$set(data, "expand", true);
			}
		},
		NodeClick(e, data) {
			this.activeId = data.id
			this.activeName = data.name
			this.editTissueItem.parent_id = data.pid
			this.editTissueItem.name = data.name
			this.editTissueItem.department_principal = data.uid
			this.$emit('getMemberList');
		},
		collapse(list) {
			var _this = this;
			list.forEach(function (child) {
				if (child.expand) {
					child.expand = false;
				}
				child.children && _this.collapse(child.children);
			});
		},
		expandChange() {
			this.toggleExpand(this.departmentTree, true);
		},
		toggleExpand(data, val) {
			var _this = this;
			if (Array.isArray(data)) {
				
				data.forEach(function (item) {
					_this.$set(item, "expand", val);
					if (item.children) {
						_this.toggleExpand(item.children, val);
					}
				});
			} else {
				this.$set(data, "expand", val);
				if (data.children) {
					_this.toggleExpand(data.children, val);
				}
			}
		},
		...mapActions([
			'handleLogOut',
		]),
		change(status) {
			this.$Message.success('设置成功');
		},
		renderContent(h, data) {
			let that = this;
			console.log(data)
			return h('Dropdown', {
				attrs: {
					trigger: 'click',
					'style': data.id === that.activeId ? 'background-color: #ff00ff;' : 'bg-color-orange'
				},
			}, [
				h('a', {
					domProps: {
						href: 'javascript:;'
					},
					on: {
						click: () => {
							this.showFlag = data.children ? true : false;
						}
					}
				}, data.label),
				h('DropdownMenu', {
					slot: 'list',
				}, [
					h('DropdownItem', {
						nativeOn: {
							click: () => {
								this.editTissue();
							}
						}
					}, '编辑部门'),
					h('DropdownItem', {
						nativeOn: {
							click: () => {
								this.addTissue();
							}
						}
					}, '添加下级部门'),
					h('DropdownItem', {
						style: {
							display: (data.id != 0 && !data.children) ? 'block' : 'none'
						},
						nativeOn: {
							click: () => {
								this.$Modal.confirm({
									title: '确定要删除吗？',
									onOk: () => {
										this.delTissue();
										this.$Message.info('删除成功');
										//删除成功
									},
								});
							}
						}
					}, '删除机构')
				]
				)
			])
		},
		// 添加成员按钮
		addMember(e) {
			this.addMemberShow = true
			this.addValue = this.newRoleList[e].name
			this.addRoleId = this.newRoleList[e].id;
		},
		// 添加成员确认添加
		addMemberOkClick() {
			let that = this;
			let data = this.addUser;
			data.token = this.token;
			data.role = this.addRoleId;
			data.department = this.department;
			this.throttle(async function () {
				let res = await manageUser(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					this.$emit('getMemberList')
				}
			}, 2000)
		},
		// 增加成员弹出框增加成员按钮
		addMemberList() {
			this.addValueList.push('')
		},
		deleteMemberList(e) {
			let index = e.currentTarget.dataset.index
			this.addValueList.splice(index, 1)
		},
		// 编辑角色确定按钮
		editMemberOkClick() {
			let that = this;
			let data = {
				token: this.token,
				id: this.editRoleForm.id,
				department: this.editRoleForm.editBranchValue,
				role: this.editRoleForm.editRoleValue,
				phone: this.editRoleForm.phone,
				password: this.editRoleForm.password,
				is_open_pool:this.editRoleForm.is_open_pool
			};
			this.throttle(async function () {
				let res = await manageUser(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					this.$emit('getMemberList')
				}
			}, 2000)
		},
		// 编辑角色按钮点击
		editRoleClick(e) {
			let id = e.currentTarget.dataset.id
			let role = e.currentTarget.dataset.role
			let department = e.currentTarget.dataset.department
			let name = e.currentTarget.dataset.name
			let phone = e.currentTarget.dataset.phone
			let is_open_pool = e.currentTarget.dataset.openpool
			console.log(e.currentTarget.dataset)
			this.editMemberShow = true
			this.editRoleForm.id = id;
			this.editRoleForm.phone = phone
			this.editRoleForm.is_open_pool = parseInt(is_open_pool) == "1"?true:false
			this.editRoleForm.editNameValue = name
			
			this.editRoleForm.editBranchValue = parseInt(department)
			this.editRoleForm.editRoleValue = parseInt(role)
			
		},
		//移除按钮点击
		deleteRoleClick(e) {
			this.deleteMemberShow = true
			let id = e.currentTarget.dataset.id
			let name = e.currentTarget.dataset.name
			this.deleteName = name
			this.deleteId = id;
		},
		//删除对跨框确认删除按钮
		deleteMemberOkClick() {
			let that = this;
			let data = {
				token: this.token,
				id: this.deleteId
			};
			this.throttle(async function () {
				let res = await deleteUser(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					this.$emit('getMemberList')
				}
			}, 2000)
		},
    unBoundOTP(row) {
      let that = this;
      let data = {
        token: this.token,
        id: row.id
      };
      this.throttle(async function () {
        let res = await unBoundOTP(that, data);
        if (res.code == 1) {
          that.$Message.success(res.msg);
          this.$emit('getMemberList')
        }
      }, 2000)
    }
	}
};
</script>
<style lang="less">
.form-inline-block {
	padding-left: 100px;
	display: inline-block;
}
a {
    color: black;
	
    text-decoration: none;
}

.tree_list {
	background-color: #FFFFFF;
	margin-left: 10px;
	padding: 20px;
}

.member_list {
	background-color: #FFFFFF;
	margin-left: 10px;
	padding: 20px;
}

.fill {
	color: #277dd3;
	cursor: pointer;
}

.item {
	/* Safari */
	width: 33.33%;
	float: left;
}

.active {
	color: #54A1F3;
}

.myblue {
	background: skyblue;
	color: #fff;
}

.myred {
	background-color: tomato;
	color: #fff;
}

.myger {
	background: green;
	color: #fff;
}

.org-bg-err {
	background-color: tomato;
	color: #fff;
}

.bg-color-orange {
	color: black;
}
.bg-color-res {
	background-color: orange;
	color: #fff;
	cursor: pointer;
}
.org-tree-node-label {
	white-space: nowrap;
}

.bg-white {
	background-color: white;
}



.bg-gold {
	background-color: gold;
}

.bg-gray {
	background-color: gray;
}

.bg-lightpink {
	background-color: lightpink;
}

.bg-chocolate {
	background-color: chocolate;
}
.selected {
  background-color: #f0f0f0;
}
.bg-tomato {
	background-color: tomato;
}

.floating {
	background: rgba(0, 0, 0, 0.7);
	width: 160px;
	height: 100px;
	position: absolute;
	color: #fff;
	padding-top: 15px;
	border-radius: 15px;
	padding-left: 15px;
	box-sizing: border-box;
	left: 0;
	top: 0;
	transition: all 0.3s;
	z-index: 999;
	text-align: left;
	font-size: 12px;
}
</style>
